import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

/**
 * Add-event / stepped flows — shared `createEvent` field for operator and player apps.
 * Distinct operation name for codegen; minimal event selection for redirect + cache.
 * Keep variables and union members aligned with the `createEvent` schema field.
 */
export const CREATE_EVENT_STEPPED_MUTATION = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  mutation createEventStepped(
    $eventName: String!
    $clubId: String!
    $isNonGolf: Boolean!
  ) {
    createEvent(name: $eventName, clubId: $clubId, isNonGolf: $isNonGolf) {
      ... on CreateEventOutput {
        event {
          id
          name
          slug
          isNonGolf
          playerCreated
        }
      }
      ... on CreateEventErrorOutput {
        errors {
          clubId
          eventName
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
